"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'channels';
exports.FETCH_ALL_CHANNELS = exports.namespace + "/FETCH_ALL_CHANNELS";
exports.SET_SELECTED_CATEGORY_ID = exports.namespace + "/SET_SELECTED_CATEGORY_ID";
exports.SET_CHANNEL_BY_ID = exports.namespace + "/SET_CHANNEL_BY_ID";
exports.SET_SELECTED_CHANNEL_ID = exports.namespace + "/SET_SELECTED_CHANNEL_ID";
exports.SAVE_RECENT_CHANNEL = exports.namespace + "/SAVE_RECENT_CHANNEL";
exports.FETCH_SELECTED_CHANNEL = exports.namespace + "/FETCH_SELECTED_CHANNEL";
exports.FETCH_SELECTED_CHANNEL_SLOT = exports.namespace + "/FETCH_SELECTED_CHANNEL_SLOT";
exports.FETCH_LINEAR_SLOT_BY_ID = exports.namespace + "/FETCH_LINEAR_SLOT_BY_ID";
exports.CLEAR_SELECTED_CHANNEL_SLOT = exports.namespace + "/CLEAR_SELECTED_CHANNEL_SLOT";
exports.SET_SLOT_FOR_SELECTED_CHANNEL = exports.namespace + "/SET_SLOT_FOR_SELECTED_CHANNEL";
exports.SET_SLOT_FOR_CHANNEL_WITH_ID = exports.namespace + "/SET_SLOT_FOR_CHANNEL_WITH_ID";
//# sourceMappingURL=constants.js.map